<template>
  <ModalWrapper
    name="ConfirmationChallenge"
    :visible="false"
    class="sell-modal"
    close-button
    close-outside
    :beforeOpen="() => {}"
    @close="() => {}">
    <template #body>
      <div class="challenge">
        <h4 class="challenge__title">
          {{ t("EmcdPuzzle | title") }}
          <strong class="challenge__strong">{{ t("EmcdPuzzle | titlePart", [game]) }}</strong>
          ?
        </h4>
        <div ref="captchaContainer"></div>
        <Spinner v-show="challenge === 'v3-hide'" />
      </div>
    </template>
  </ModalWrapper>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { Spinner } from "@emcd-shared/base-loader";
import ChallengeService from "../challengeService.js";
import ModalWrapper from "@/components/ui/modal/modalWrapper.vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "@/stores/user";

const props = defineProps({
  challenge: {
    type: String,
    required: true,
  },
  challengeData: {
    type: [Object, String, Number],
    default: () => null,
  },
});

const emit = defineEmits(["resolve", "reject"]);

const games = [
  "Age of Empires",
  "Hearthstone",
  "Diablo 4",
  "Fifa",
  "Arma",
  "Fallout 4",
  "Supreme Commander",
  "Ghost of Tsushima",
  "Helldivers 2",
  "Hunt Showdown",
  "Last of Us",
  "Witcher 3",
  "Apex Legends",
  "Bloodborne",
  "Elden Ring",
  "Hunt Showdown",
  "Helldivers",
  "Elden Ring",
  "Total War: Warhammer 3",
  "Stardew Valley",
  "Valheim",
  "League of Legends",
  "Hearthstone",
];

const { t } = useI18n();

const { setCaptchaToken } = useUserStore();
const captchaContainer = ref(null);

const game = computed(() => {
  if (games.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * games.length);
  return games[randomIndex];
});

onMounted(async () => {
  try {
    console.log("captcha mounted before check");
    const token = await ChallengeService.check({
      node: captchaContainer.value,
      challenge: props.challenge,
      challengeData: props.challengeData,
      context: props.context,
    });
    console.log(token, "token onMounted conf");
    setCaptchaToken(token);
    emit("resolve", token);
  } catch (e) {
    emit("reject", e);
  }
});
</script>

<style scoped lang="scss">
// .sell-modal {
//   position: absolute;
//   top: 0;
//   left: 0;
//   max-width: 100px !important;
//   width: 100px !important;
//   height: 1000px !important;
//   z-index: 1000000000000;
//   background: coral;
// }

.challenge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 300px;
  min-height: 150px;
  box-sizing: border-box;

  &__title {
    text-align: center;
    color: var(--color-1-text, var(--text-1));
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 30px;
  }

  &__strong {
    color: var(--text-5);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: line-through;
  }
}
</style>
